import { render, staticRenderFns } from "./DetailsDrawer.vue?vue&type=template&id=043b1313&scoped=true"
import script from "./DetailsDrawer.vue?vue&type=script&lang=js"
export * from "./DetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./DetailsDrawer.vue?vue&type=style&index=0&id=043b1313&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043b1313",
  null
  
)

export default component.exports